module.exports = __webpack_public_path__ + "img/type_BUG.72e87d8f.png";